import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultPUR6010_R01DetailDto, defaultPUR6010_R01HeaderDto, PUR6010_R01DetailDto, PUR6010_R01HeaderDto } from './Dto_PUR6010_R01';

export interface PUR6010_R01Filter {
	
	paymentDateRange: DateRange | undefined	;	//지불기간
	tradeDateRange: DateRange | undefined;		//매출기간
	customCd: string;
	customNm: string;
	compCd: string;
	compNm: string;
	tradeType: string;							//지불구분

}
export interface Store_PUR6010_R01 {
	PUR6010_R01Filter: PUR6010_R01Filter;
	PUR6010_R01PastFilter: PUR6010_R01Filter;
	setPUR6010_R01Filter: (filter: Partial<Store_PUR6010_R01['PUR6010_R01Filter']>) => void;
	setPUR6010_R01PastFilter: (filter: Store_PUR6010_R01['PUR6010_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	PUR6010_R01List: PUR6010_R01HeaderDto[];
	setPUR6010_R01List: (dataList: PUR6010_R01HeaderDto[]) => void;

	editPUR6010_R01: PUR6010_R01HeaderDto | null;
	setEditPUR6010_R01: (editSale: PUR6010_R01HeaderDto | null) => void;

	selectedPUR6010_R01: PUR6010_R01HeaderDto | undefined;
	setSelectedPUR6010_R01: (data: PUR6010_R01HeaderDto | undefined) => void;
	initSelectedPUR6010_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPUR6010_R01DetailList: string[];
	setDeletedPUR6010_R01DetailList: (idList: string[]) => void;
	addDeletedPUR6010_R01DetailList: (idList: string[]) => void;
	removeDeletedPUR6010_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	PUR6010_R01DetailList: PUR6010_R01DetailDto[];
	setPUR6010_R01DetailList: (data: PUR6010_R01DetailDto[]) => void;
	insertPUR6010_R01DetailList: (data: PUR6010_R01DetailDto[], index?: number) => void;
	removePUR6010_R01DetailList: (index: number) => void;
	updatePUR6010_R01DetailList: (index: number, data: PUR6010_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedPUR6010_R01DetailList: string[];
	setSelectedPUR6010_R01DetailList: (idList: string[]) => void;
	addSelectedPUR6010_R01DetailList: (idList: string[]) => void;
	removeSelectedPUR6010_R01DetailList: (idList?: string[]) => void;
	initSelectedPUR6010_R01DetailList: () => void;

	originalPUR6010_R01DetailList: PUR6010_R01DetailDto[];
	setOriginalPUR6010_R01DetailList: (data: PUR6010_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;			setDetailFetchTrigger: (trigger: boolean) => void;
	detailCreateTrigger: boolean;			setDetailCreateTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultPUR6010_R01Filter : PUR6010_R01Filter = {
	
	paymentDateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	tradeDateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: '',
	compCd: '',
	compNm: '',
	tradeType: ''
};

export const noteCreateFlgMap_PUR6010_R01 = [
	{ title: '자수', value: 'IN' },
	{ title: '타수', value: 'OUT' },
]

export const usePUR6010_R01Store = create<Store_PUR6010_R01>((set) => ({
	PUR6010_R01Filter: defaultPUR6010_R01Filter,
	PUR6010_R01PastFilter: defaultPUR6010_R01Filter,
	setPUR6010_R01Filter: (update) => set((state) => ({
		PUR6010_R01Filter: {
			...state.PUR6010_R01Filter,
			...update
		}
	})),
	setPUR6010_R01PastFilter: (filter: Store_PUR6010_R01['PUR6010_R01PastFilter']) => set((state) => {
		return {
			...state,
			PUR6010_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	PUR6010_R01List: [],
	setPUR6010_R01List: (dataList: PUR6010_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PUR6010_R01List: dataList
		}
	}),

	editPUR6010_R01: defaultPUR6010_R01HeaderDto,
	setEditPUR6010_R01: (editSale: PUR6010_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editPUR6010_R01: editSale
		}
	}),

	selectedPUR6010_R01: undefined,
	
	setSelectedPUR6010_R01: (data: PUR6010_R01HeaderDto | undefined) => set((state) => {
		return { 
			selectedPUR6010_R01: data,
			selectedPUR6010_R01DetailList: [], deletedPUR6010_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedPUR6010_R01: () => set({ selectedPUR6010_R01: undefined, PUR6010_R01DetailList: [], detailFetchTrigger: false }),

	// ====== 매출 상세(디테일) 데이터 ======
	PUR6010_R01DetailList: [],
	setPUR6010_R01DetailList: (data: PUR6010_R01DetailDto[]) => set((state) => {
		let newList: PUR6010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPUR6010_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PUR6010_R01DetailList: newList
		}
	}),
	insertPUR6010_R01DetailList: (data: PUR6010_R01DetailDto[], index?: number) => set((state) => {
		let newPUR6010_R01DetailList = [...state.PUR6010_R01DetailList];

		let targetRowData = newPUR6010_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newPUR6010_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newPUR6010_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newPUR6010_R01DetailList = newPUR6010_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newPUR6010_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultPUR6010_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newPUR6010_R01DetailList.splice(index, 0, ...newData);
		} else {
			newPUR6010_R01DetailList.push(...newData);
		}

		return {
			...state,
			PUR6010_R01DetailList: newPUR6010_R01DetailList
		}
	}),
	removePUR6010_R01DetailList: (index: number) => set((state) => {
		const newPUR6010_R01DetailList = [...state.PUR6010_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PUR6010_R01DetailList: newPUR6010_R01DetailList
		}
	}),
	updatePUR6010_R01DetailList: (valueIndex: number, data: PUR6010_R01DetailDto) => set((state) => {
		const _PUR6010_R01DetailList = state.PUR6010_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			PUR6010_R01DetailList: _PUR6010_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPUR6010_R01DetailList: [],
	setDeletedPUR6010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPUR6010_R01DetailList: idList
		}
	}),
	addDeletedPUR6010_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedPUR6010_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.PUR6010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PUR6010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPUR6010_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedPUR6010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPUR6010_R01DetailList: [...state.deletedPUR6010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPUR6010_R01DetailList: [],
	setSelectedPUR6010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPUR6010_R01DetailList: idList
		}
	}),
	addSelectedPUR6010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedPUR6010_R01DetailList = [...state.selectedPUR6010_R01DetailList];
		if(idList.length > 0) {
			_selectedPUR6010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedPUR6010_R01DetailList: _selectedPUR6010_R01DetailList
		}
	}),
	removeSelectedPUR6010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPUR6010_R01DetailList: [...state.selectedPUR6010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPUR6010_R01DetailList: () => set({ selectedPUR6010_R01DetailList: [] }),

	originalPUR6010_R01DetailList: [],
	setOriginalPUR6010_R01DetailList: (data: PUR6010_R01DetailDto[]) => set((state) => {
		let newList: PUR6010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPUR6010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPUR6010_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),
	detailCreateTrigger: false,		setDetailCreateTrigger: (trigger: boolean) => set({ detailCreateTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		PUR6010_R01Filter: defaultPUR6010_R01Filter,
		PUR6010_R01PastFilter: defaultPUR6010_R01Filter,
		PUR6010_R01List: [],
		selectedPUR6010_R01: undefined,
		PUR6010_R01DetailList: [],
		deletedPUR6010_R01DetailList: [],
		selectedPUR6010_R01DetailList: [],
		editPUR6010_R01: defaultPUR6010_R01HeaderDto,
		allCount: 0,
		detailFetchTrigger: false,
		detailCreateTrigger: false,
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
